import { render } from "./summary-submit-card.vue?vue&type=template&id=12f323c2"
import script from "./summary-submit-card.vue?vue&type=script&lang=js"
export * from "./summary-submit-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__